import { ReactElement } from 'react'
import styled from 'styled-components'

import { ProfileIcon } from 'components/Icons/ProfileIcon'
import Heading from 'components/v2/Heading'
import { IAvatarProps } from './types'

const AvatarContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`

const StyledAvatarIcon = styled(ProfileIcon)<{ fill?: string; size: string }>`
  fill: ${({ fill }): string => fill ?? '#F0F0F0'};
  transition: 0.2s;
  width: ${({ size }): string => size};
`

const Avatar = ({ className, name, size = 'md' }: IAvatarProps): ReactElement => {
  const profileColors = ['#5D59D7', '#A86EEB', '#27EDC7', '#FFA800', '#F0F0F0']
  const userColor = profileColors[(name ?? 'A').charCodeAt(0) % profileColors.length]

  const sizes = {
    sm: '24px',
    md: '30px',
    lg: '36px'
  }

  return (
    <AvatarContainer className={className}>
      <StyledAvatarIcon fill={userColor} size={sizes[size]} />
      {name && <Heading.Body>{name}</Heading.Body>}
    </AvatarContainer>
  )
}

export default Avatar
